import { FeatureConfig } from '@aston/feature-flags';

const acc = true;

export const DefaultFeatureFlags: FeatureConfig = {
	//// DELETE THOSE, OR MAKE THEM DEFAULTS ?
	// Force superdebtor legal id using an input mask
	superDebtorLegalIdMask: !acc,
	// PC functional ID validation
	payingCenterFunctionalIdValidation: !acc,
	// Allow workflow scheduling
	adminWorkflowScheduling: !acc,
}
